import { Center, CenterProps, Spinner, SpinnerProps } from '@chakra-ui/react'

interface LoadingSpinnerProps extends CenterProps {
  spinnerProps?: SpinnerProps
}

export const LoadingSpinner = ({
  spinnerProps,
  ...props
}: LoadingSpinnerProps) => (
  <Center w="full" height="full" {...props}>
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="product.secondary"
      size="xl"
      {...spinnerProps}
    />
  </Center>
)
